import account from './account'
import address from './address'
import load from './load'
import branding from './branding'
import currencies from './currencies'
import carManage from './carManage'
import companyExtra from './companyExtra'
import dashboard from './dashboard'
import fileManager from './fileManager'
import featur from './featur'
import forms from './forms'
import feeedback from './feedback'
import geolocations from './geolocations'
import menus from './menus'
import nav from './nav'
import pages from './pages'
import roles from './roles'
import items from './items'
import shared from './shared'
import systemManage from './systemManage'
import security from './security'
import users from './users'
import unit from './unit'
import userGroup from './userGroup'
import widgetAreas from './widgetAreas'
import websiteShipment from './websiteShipment'
import tariff from './tariff'
import webservice from './webservice'
import message from './message'
import urlShortened from './urlShortened'
import financial from './financial'
import giftCard from './giftCard'
import couponTypes from './couponTypes'
import validation from './validation'
import policy from './policy'
import promotions from './promotions'
import campaign from './campaign'
import crm from './crm'
import cms from './cms'
import questionnaire from './questionnaire'
import jsonEditor from './jsonEditor'
import formulaMaker from './formulaMaker'
import timeSheet from './timeSheet'
import meta from './meta'
import blog from './blog'
import map from './map'
import billOfLading from './bill-of-lading'

// refactored
import shipment from './shipment'
import log from './log'
import chart from './chart'
import constants from './constants'
import commercialBanking from './commercial-banking'
import toast from './toast'

import baraneh from './baraneh'
import editorType from './editorType'
import credential from './credential'

export default {
  direction: 'ltr',
  account,
  address,
  load,
  branding,
  currencies,
  carManage,
  companyExtra,
  dashboard,
  fileManager,
  forms,
  featur,
  feeedback,
  geolocations,
  menus,
  nav,
  pages,
  roles,
  items,
  shared,
  security,
  systemManage,
  users,
  unit,
  userGroup,
  widgetAreas,
  websiteShipment,
  tariff,
  webservice,
  message,
  urlShortened,
  financial,
  giftCard,
  couponTypes,
  validation,
  policy,
  promotions,
  campaign,
  crm,
  cms,
  questionnaire,
  jsonEditor,
  formulaMaker,
  timeSheet,
  meta,
  blog,
  map,
  billOfLading,

  // refactored
  shipment,
  log,
  chart,
  constants,
  commercialBanking,
  toast,

  // external
  baraneh,

  editorType,
  credential
}
